"use strict";

var _toConsumableArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function queueExec(func, waitTime) {
  var funcQueue = [];
  var isWaiting = false;

  function executeFunc() {
    isWaiting = true;
    func.apply(void 0, arguments);
    setTimeout(play, waitTime);
  }

  ;

  function play() {
    isWaiting = false;
    var params = funcQueue.shift();

    if (params !== undefined) {
      executeFunc.apply(void 0, _toConsumableArray(params));
    }
  }

  ;
  return function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    if (isWaiting) {
      funcQueue.push(params);
    } else {
      executeFunc.apply(void 0, params);
    }
  };
}

exports.queueExec = queueExec;
;